import React, { useState, useRef, useEffect } from "react";
import styles from "./EmployeeList.module.scss";

const DepartmentPopup = ({ departments }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const popupRef = useRef(null);

  const filteredDepartments = departments.filter((department) =>
    department.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className={styles.departmentsPopup} ref={popupRef}>
      <div className={styles.padding}>
        <input
          type="text"
          placeholder="Search departments..."
          value={searchQuery}
          onChange={(event) => setSearchQuery(event.target.value)}
          className={styles.searchInput}
          autoFocus
        />
      </div>
      <div className={styles.popupContent}>
        {filteredDepartments.length > 0 ? (
          filteredDepartments.map((department, index) => (
            <div key={`department-${index}`} className={styles.departmentItem}>
              {department}
            </div>
          ))
        ) : (
          <div className={styles.noResults}>No matching departments found</div>
        )}
      </div>
    </div>
  );
};

export default DepartmentPopup;
